module.exports = __webpack_public_path__ + "img/icon_individual.c6ca25a5.svg";